// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--h-biI","body":"body--3uH-Y"};